
<template>
  <div v-if="settings">
    <div v-if="settings.identityProvider == 'COGNITO' && !forceLocal" class="gp-has-header">
      <mdb-spinner/>
    </div>


    <div class="full-view" v-if="settings.identityProvider == 'LOCAL' || forceLocal"
         :style="'background-image: url(\'' + settings.loginBackground + '\')'"
    >
      <mdb-mask class="gradient d-flex justify-content-center align-items-center overflow-auto">
        <div class="login-form">
          <div v-if="loggedIn">Logged in.
            <mdb-spinner/>
          </div>
          <div v-else>
            <mdb-card class="mb-4 gp-has-header" style="width:100%">
              <mdb-card-header>
                <a @click="$router.push('/')" href="#">
                  <img class="logo-top"
                       :src="settings.loginLogo"/>
                </a>
              </mdb-card-header>
            </mdb-card>

            <mdb-card style="width:100%">
              <mdb-card-header>
                <p class="h5">Sign In</p>
              </mdb-card-header>
              <mdb-card-body>
                <div class="text-center danger-color" style="margin-top: 10px;" v-if="error"><span
                  style="padding: 10px">{{ error }}</span>
                </div>
                <form v-on:submit.prevent="doLogin">
                  <div class="grey-text text-left">
                    <mdb-input id="user-name" icon="user" label="Username/Email" type="text" v-model="user"/>
                    <mdb-input icon="lock" label="Password" type="password" v-model="password"/>
                  </div>
                  <div class="text-center">
                    <mdb-btn type="submit" :disabled="!user || !password">Login</mdb-btn>
                  </div>
                  <div class="text-center">
                    <a @click.prevent="showPasswordHelp=true" href="">I forgot my password</a>
                  </div>

                  <div class="text-center">
                    Not already a member?
                    <router-link to="/register">Register</router-link>
                  </div>
                </form>
              </mdb-card-body>
            </mdb-card>
          </div>

        </div>
      </mdb-mask>
      <mdb-modal v-if="showPasswordHelp" @close="showPasswordHelp = false" size="lg">
        <mdb-modal-header class="primary-color text-white" :close="true" center>
          <h4 class="heading">Password Help</h4>
        </mdb-modal-header>
        <mdb-modal-body>
          <mdb-input type="text" v-model="email" label="Username or Email"/>
        </mdb-modal-body>
        <mdb-modal-footer center>
          <mdb-btn @click="showPasswordHelp=false">Close</mdb-btn>
          <mdb-btn :disabled="!email" @click="submitForgot">Submit</mdb-btn>
        </mdb-modal-footer>
      </mdb-modal>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {CognitoAuth} from 'amazon-cognito-auth-js';
import api from "../services/groupsPlaceApi";
import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbInput,
  mdbMask,
  mdbModal,
  mdbModalBody,
  mdbModalFooter,
  mdbModalHeader,
  mdbSpinner,
  mdbView
} from 'mdbvue';
import store from "../store";

export default {
  name: 'Login',
  components: {
    mdbInput,
    mdbBtn,
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbCardFooter,
    mdbSpinner,
    mdbMask,
    mdbView,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalFooter
  },
  computed: mapState({
                       apiKey: state => state.apiKey,
                       secret: state => state.secret,
                       userDetails: state => state.userDetails,
                       loggedIn: state => state.loggedIn,
                       settings: state => state.settings
                     }),
  data() {
    return {
      forceLocal: false,
      user: "",
      password: "",
      error: "",
      showPasswordHelp: false,
      ignoreConversion: false,
      email: "",
      backendUrl: process.env.BACKEND_URL
    }
  },
  watch: {
    settings(n, o) {
      if (!o || !o.identityProvider) {
        if (n.identityProvider == "COGNITO" && !this.forceLocal) {
          this.cognitoLogin()
        }
      }
    }
  },
  mounted() {
    document.title = "Login"
    if (this.loggedIn) {
      this.$router.push("/")
      return
    }

    if (this.$route.query.forceLocal == "Y") this.forceLocal = true

    if (this.$route.query.msg) this.error = this.$route.query.msg
    if (this.settings.identityProvider == "LOCAL" || this.forceLocal) {
      let el = document.getElementById("user-name")
      if (el) el.focus()
    }
    if (this.settings.identityProvider == "COGNITO" && !this.forceLocal) {
      this.cognitoLogin()
    }

  },
  methods: {
    /*doIgnoreConversion() {
      window.localStorage.setItem("ignoreSecurityConversion", "true")
      this.ignoreConversion = true
    },
    doBypassMessage() {
      this.ignoreConversion = true
      this.cognitoLogin()
    },*/
    cognitoLogin() {
      /*if (this.settings.tenantId == 1 && this.settings.showSecurityConversion) {
        let ignore = window.localStorage.getItem("ignoreSecurityConversion")
        if (! (ignore && ignore == "true") && !this.ignoreConversion) {
          this.showConversionMessage = true
          return
        }
      }*/
      let auth = new CognitoAuth(this.settings.cognitoAuthData);
      auth.userhandler = {
        onSuccess: (result) => {
          store.dispatch("setCognitoAuth", auth)
          api.post("/user/cognitoLogin", {token: auth.getSignInUserSession().getIdToken().jwtToken}).then(
            (details) => {
              let cred = details.data.authKey
              let secret = details.data.secret
              let isNewUser = details.data.isNewUser
              if (cred) {
                api.completeLogin(cred,secret, isNewUser)
              } else this.error = "Invalid response from server."
            },
            (error) => {
              this.$notify.error({message: error.response.data, timeOut: 4000})
            })
        },
        onFailure: function (err) {
          this.$store.commit("loggedIn", false)
          this.$router.push("/")
        }
      };
      auth.getSession();
    },
    submitForgot: function () {
      this.showPasswordHelp = false
      this.$store.dispatch("setExecuting", true)
      api.post("/user/forgotPassword", {email: this.email, src: "vue-app"}).then(
        (details) => {
          this.$notify.success({message: "Please check your email", timeOut: 5000})
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 10000})
          this.showPasswordHelp = true
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    doLogin: function () {
      this.$store.dispatch("setExecuting", true)
      this.error = ""
      api.post("/user/login", {user: this.user, password: this.password}).then(
        (details) => {
          let auth = details.data.authKey
          let secret = details.data.secret
          if (auth && secret) {
            api.completeLogin(auth, secret, false)
          } else this.error = "Invalid response from server."
        },
        (error) => {
          this.error = error.response.data
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }
}
</script>

<style scoped>
@media screen and (max-width: 749px ) {
  .login-form {
    margin: auto;
    width: 80%;

  }
}

@media screen and (min-width: 750px ) {
  .login-form {
    margin: auto;
    width: 50%;
  }
}

.gradient {
  background: -moz-linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
  background: -webkit-linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
  background: -webkit-gradient(linear, 45deg, from(rgba(42, 27, 161, 0.7)), to(rgba(29, 210, 177, 0.7)));
  background: -o-linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
  background: linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
  height: calc(100vh);
}

.full-view {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  height: calc(100vh);
}

.logo-top {
  max-width: 60%;
  margin: auto;
}

</style>
